export default {
  props: {
    layout: {
      type: String,
      default: '2col',
    },
  },

  data() {
    return {
      visibilityRules: {
        left: false,
        center: false,
        right: false,
      },
    }
  },

  mounted() {
    this.setVisibilityRules()
  },

  methods: {
    setVisibilityRules() {
      switch (this.layout) {
        case '1col':
          this.setLayout_1col()

          break

        case '2col':
          this.setLayout_2col()

          break

        case '3col':
          this.setLayout_3col()

          break

        default:
          this.setLayout_3col()

          break
      }
    },

    setLayout_1col() {
      this.visibilityRules.center = true
    },

    setLayout_2col() {
      this.visibilityRules.left = true
      this.visibilityRules.right = true
    },

    setLayout_3col() {
      Object.keys(this.visibilityRules).forEach((key) => {
        this.visibilityRules[key] = true
      })
    },
  },
}
